import { SignatureDocument } from 'src/signature/stores/signature.store';
import { FormSignatureRequestModel } from 'src/api/model/formSignatureRequestModel';
import { InvoiceSignatureRequestModel } from 'src/api/model/invoiceSignatureRequestModel';
import { ProjectSignatureRequestModel } from 'src/api/model/projectSignatureRequestModel';
import { signatureTypeEnumToString } from './signatureTypeEnumToString';

export const getDocumentId = (document: SignatureDocument): string | null => {
    if (isFormSignature(document)) {
        return `${document.submittingId}`;
    }

    if (isInvoiceSignature(document)) {
        return `${document.invoiceId}_${document.signatureType}`;
    }

    if (isProjectSignature(document)) {
        return `${document.projectId}_${document.signatureType}`;
    }

    return null;
};

export const getDocumentName = (document: SignatureDocument): string | undefined => {
    if (isFormSignature(document)) {
        return `${document.formName}`;
    }

    if (isInvoiceSignature(document) || isProjectSignature(document)) {
        return signatureTypeEnumToString(document.signatureType);
    }
};

export const isFormSignature = (
    document?: SignatureDocument
): document is FormSignatureRequestModel => {
    return !!document && (document as FormSignatureRequestModel).submittingId !== undefined;
};

export const isInvoiceSignature = (
    document?: SignatureDocument
): document is InvoiceSignatureRequestModel => {
    return !!document && (document as InvoiceSignatureRequestModel).invoiceId !== undefined;
};

export const isProjectSignature = (
    document?: SignatureDocument
): document is ProjectSignatureRequestModel => {
    return !!document && (document as ProjectSignatureRequestModel).projectId !== undefined;
};

export const getDocumentPdfUrl = (
    visitActionRequestId?: string,
    document?: SignatureDocument
): string | undefined => {
    if (isFormSignature(document)) {
        return `/api/forms/${document.submittingId}/print/?visitActionRequestId=${visitActionRequestId}`;
    }
};
